import { render, staticRenderFns } from "./PRealQuality.vue?vue&type=template&id=49343489"
import script from "./PRealQuality.vue?vue&type=script&lang=js"
export * from "./PRealQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports